import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useClientNoteEditPageRedirect = () => {
  const {
    doRedirectOnPrevPage,
    doRedirectWithSavePageUrl: redirectOnEditNote,
    doSavePageUrl,
    prevPageUrl,
  } = usePagesRedirect('clientsNoteEditPage');

  return {
    redirectOnEditNote,
    doRedirectOnPrevPage,
    doSavePageUrl,
    prevPageUrl,
  };
};
